import { render, staticRenderFns } from "./FeaturedCard.vue?vue&type=template&id=613df644"
import script from "./FeaturedCard.vue?vue&type=script&lang=js"
export * from "./FeaturedCard.vue?vue&type=script&lang=js"
import style0 from "./FeaturedCard.vue?vue&type=style&index=0&id=613df644&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports